// @flow
import {
    completeFollowSearchModal,
    completeSignUpModal,
    getOpenModal,
    getSignupReferralHouse,
    OPEN_SIGN_UP_MODAL,
    openLoginModal,
    openSetPasswordModal,
} from './modal';
import { bidderExistsSuccess } from './bidderExists';
import { createSelector } from 'reselect';
import { fetchBidderDataIfNeeded } from './user';
import { getDeployment } from './config';
import { getRegisterAccountAnalytics } from './analytics';
import type { GlobalState } from '../rootReducer';
import { modalTypes } from '../../enums';
import { OPEN_FOLLOW_SEARCH_MODAL_FROM_CHECKER } from './shouldLogin';
import { postCreateAccount } from '../api/bidder';

/* Action Types */
export const CREATE_ACCOUNT_FAIL = 'la/ui/createAccount/FAIL';
export const CREATE_ACCOUNT_REQUEST = 'la/ui/createAccount/REQUEST';
export const CREATE_ACCOUNT_SUCCESS = 'la/ui/createAccount/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: null,
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case CREATE_ACCOUNT_FAIL:
            return {
                ...state,
                error: action.payload,
                submitted: false,
                success: false,
            };
        case CREATE_ACCOUNT_REQUEST:
            return {
                ...state,
                error: null,
                submitted: true,
                success: false,
            };
        case CREATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                error: null,
                submitted: false,
                success: true,
            };
        case OPEN_SIGN_UP_MODAL:
        case OPEN_FOLLOW_SEARCH_MODAL_FROM_CHECKER:
            return {
                ...state,
                error: null,
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.createAccount;

export const getCreateAccountState = createSelector(stateSelector, state => state);

/* ACTION CREATORS */
export const submitCreateAccount = (emailAddress: string, agree: any, attributionData: any) => async (
    dispatch: Function,
    getState: Function
) => {
    try {
        const state = getState();
        const deployment = getDeployment(state);
        const signupReferralHouse = getSignupReferralHouse(state);

        dispatch({
            payload: emailAddress,
            type: CREATE_ACCOUNT_REQUEST,
        });

        const response = await postCreateAccount({
            agree,
            deployment,
            emailAddress,
            signupReferralHouse,
        });
        const bidderId = response.payload.bidderId;
        const token = response.payload.createToken;

        const analytics = getRegisterAccountAnalytics(getState(), bidderId, attributionData);

        dispatch({
            meta: {
                actionTime: Date.now(),
                analytics,
            },
            payload: token,
            type: CREATE_ACCOUNT_SUCCESS,
        });

        if (getOpenModal(state) === modalTypes.FOLLOW_SEARCH) {
            dispatch(completeFollowSearchModal());
        } else {
            dispatch(completeSignUpModal());
            dispatch(openSetPasswordModal());
        }
        dispatch(fetchBidderDataIfNeeded(token, true));
    } catch (error) {
        if (error === 'User Already Exists') {
            dispatch(bidderExistsSuccess(emailAddress));
            if (getOpenModal(getState()) !== modalTypes.FOLLOW_SEARCH) {
                dispatch(openLoginModal());
            }
        }

        dispatch({
            error: true,
            meta: { emailAddress },
            payload: error,
            type: CREATE_ACCOUNT_FAIL,
        });
    }
};
